(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.exportPaymentsToNetSuite',
      ExportPaymentsToNetSuiteModalController
    );

  ExportPaymentsToNetSuiteModalController.$inject = [
    '$uibModalInstance',
    '$stateParams',
    'moment',
    'abp.services.finance.debugTools',
  ];

  function ExportPaymentsToNetSuiteModalController(
    $uibModalInstance, 
    $stateParams,
    moment,
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.exportPaymentsToNetSuite = exportPaymentsToNetSuite;
    vm.cancel = cancel;

    vm.dateRangeModel = new DateRangeModel(
      $stateParams.startDate,
      $stateParams.endDate
    );

    function DateRangeModel(startDate, endDate, eventCallback) {
      const opt = App.createDateRangePickerOptions();
      this.options = opt;
      this.options.eventHandlers = {
        'apply.daterangepicker': () => {
          eventCallback();
        },
      };
    }

    function exportPaymentsToNetSuite() {
      if (!App.isFormValid(vm.exportPaymentsToNetSuiteForm)) return;

      vm.saving += 1;
      debugToolsSvc
        .exportPaymentsToNetSuite({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          paymentNumber: vm.paymentNumber,
          startDate: vm.dateRangeModel.startDate 
          ? vm.dateRangeModel.startDate.format('YYYY-MM-DD') : null,
          endDate: vm.dateRangeModel.endDate 
          ? vm.dateRangeModel.endDate.format('YYYY-MM-DD') : null,
          isUpdate: vm.isUpdate,
          delay: vm.delay
        })
        .success(() => {
          abp.notify.success(App.localize('Success'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();